module.exports = __webpack_public_path__ + "static/img/8.9c96950.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/zh/8.png
// module id = t3m2
// module chunks = 0